/* eslint-disable no-useless-catch */
import { API } from "../api";
import { COMMUNICATION_HISTORY } from "../constants/url.constant";

export const GET_COMMENT = "GET_COMMENT";
export const ADD_COMMENT = "ADD_COMMENT";
export const UPDATE_COMMENT = "UPDATE_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";

export const getComments = (orderId) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${COMMUNICATION_HISTORY}/${orderId}`);

      dispatch({
        type: GET_COMMENT,
        payload: res?.count > 0 ? res.rows : []
      });

      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addComment = (data) => {
  const { orderId } = data;
  return async (dispatch) => {
    try {
      const res = await API.post(`${COMMUNICATION_HISTORY}/`, data);

      if (res) dispatch(getComments(orderId));

      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateComment = (id, data) => {
  const orderId = data.orderId;

  return async (dispatch) => {
    try {
      delete data.orderId;
      const res = await API.put(`${COMMUNICATION_HISTORY}/${id}`, data);

      if (res) dispatch(getComments(orderId));

      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const deleteComment = (id, orderId) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${COMMUNICATION_HISTORY}/${id}`);
      if (res) {
        dispatch(getComments(orderId));
      }

      return res;
    } catch (error) {
      throw error;
    }
  };
};

const initialState = {
  isLoading: false,
  loaded: false,
  comments: []
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_COMMENT:
      return {
        ...state,
        comments: payload
      };
    default:
      return state;
  }
}
